module.exports = __webpack_public_path__ + "static/UNITY-Square-One-5th-floor-traditional_v2-en-b57224dd9c94bc01f2cd81da50c77473.pdf";